export default "Exonération CSPE exploitation agricole — Accise électricité | Solution Éco France";
